import { Folder } from 'owa-folders';
import DisposalType from 'owa-service/lib/contract/DisposalType';
import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';

/**
 * Empty folder without the confirm dialog
 * @param folder the folder to be emptied
 * @param disposalType the disposalType
 * @param clientLastSyncTime client last sync time used as a watermark
 * @param rowKeysToExclude item ids to exclude from empty folder operation
 * @param tableViewId id of the tableView where empty operation is performed.
 * @param deletedItemsFolderId id of the deleted items folder for the mbx to which the folder being emptied belongs
 * @param shouldSupportBulkActions flag indicating whether the bulk actions is being supported or not
 */
const emptyFolderWithoutConfirmation = action(
    'emptyFolderWithoutConfirmation',
    (
        folder: Folder,
        disposalType: DisposalType,
        deleteSubFolders: boolean,
        clientLastSyncTime: Date,
        rowKeysToExclude: string[],
        tableViewId: string,
        deletedItemsFolderId: string,
        shouldSupportBulkActions: boolean
    ) => {
        const folderTotalCount = folder.TotalCount;
        return addDatapointConfig(
            {
                name: 'TnS_EmptyFolderAction',
                customData: {
                    folderTotalCount,
                    disposalType,
                    deleteSubFolders,
                },
            },
            {
                folder,
                disposalType,
                deleteSubFolders,
                clientLastSyncTime,
                rowKeysToExclude,
                tableViewId,
                deletedItemsFolderId,
                shouldSupportBulkActions,
            }
        );
    }
);

export default emptyFolderWithoutConfirmation;
